export default __webpack_public_path__ + "static/media/Small Lifesteal Spellbomb.1b687a1a.PNG";